module.exports = __webpack_public_path__ + "static/media/cornerMatTan10.efc120d6.png";